import { ImageIcon } from 'lucide-react'
import { Select, Input, InputGroup, InputGroupText } from 'twyne-new.ui'

import { useCraftProp } from '../../utils'
import ImageField from '../Image/Field'
import PositionImageProperty from '../PositionImage'

const Image = ({ name }) => {
  const { value: image = {}, setValue: setImage } = useCraftProp(name)

  const handleChange = value => {
    setImage({ ...image, ...value })
  }

  return <div className='flex flex-col gap-2'>
    <ImageField value={image} onChange={({ value: newValue }) => handleChange({ ...newValue })} />

    <PropertyItem title='Size'>
      <Select
        options={SIZE_OPTIONS}
        value={image.size}
        promptTextCreator={str => `Create an arbitrary option "${str}"`}
        onChange={option => handleChange({ size: option?.value })}
        disabled={!image.src}
        creatable
        clearable
      />
    </PropertyItem>

    <PropertyItem title='Position'>
      <PositionImageProperty
        value={image.position}
        onChange={position => handleChange({ position })}
        disabled={!image.src}
        prefix='bg-'
      />
    </PropertyItem>

    <PropertyItem title='Attach'>
      <Select
        options={ATTACHMENT_OPTIONS}
        value={image.attachment}
        onChange={option => handleChange({ attachment: option?.value })}
        disabled={!image.src}
        clearable
      />
    </PropertyItem>

    <PropertyItem title='Repeat'>
      <Select
        options={REPEAT_OPTIONS}
        value={image.repeat}
        onChange={option => handleChange({ repeat: option?.value })}
        disabled={!image.src}
        clearable
      />
    </PropertyItem>
  </div>
}

const ImagePreview = ({ image }) => <InputGroup>
  <InputGroupText addonType='prepend'>
    {!image?.src ? <ImageIcon size={14} /> : <img src={image.src} alt="feature_image" className='w-4 h-4 cursor-pointer' />}
  </InputGroupText>
  <Input className='text-left' value={image?.name} readOnly placeholder='Image' />
</InputGroup>

const PropertyItem = ({ children, title }) => <>
  <div className='grid grid-cols-4 gap-2 items-center'>
    <div className='col-span-1'>{title}</div>
    <div className='col-span-3'>
      {children}
    </div>
  </div>
</>

export { Image, ImagePreview }

const ATTACHMENT_OPTIONS = [
  { label: 'Scroll', value: 'bg-scroll' },
  { label: 'Fixed', value: 'bg-fixed' },
  { label: 'Local', value: 'bg-local' },
]

const SIZE_OPTIONS = [
  { label: 'Auto', value: 'auto' },
  { label: 'Cover', value: 'cover' },
  { label: 'Contain', value: 'contain' },
]

const REPEAT_OPTIONS = [
  { label: 'Repeat', value: 'bg-repeat' },
  { label: 'Repeat X', value: 'bg-repeat-x' },
  { label: 'Repeat Y', value: 'bg-repeat-y' },
  { label: 'Space', value: 'bg-space' },
  { label: 'Round', value: 'bg-round' },
  { label: 'No Repeat', value: 'bg-no-repeat' },
]

